export default __webpack_public_path__ + "static/media/109room.7b3e694a.jpg";